/* freight_quote.js — MGS Freight Quote Form (Phase 1)
 * Simplified Version: Bloated checkbox hunting removed.
 */
(function () {
  'use strict';

  var skipUsed = false;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function injectStyle() {
    if (document.getElementById('mgs-fq-style')) return;
    var style = document.createElement('style');
    style.id = 'mgs-fq-style';
    style.textContent = '.mgs-fq-ack-hidden { display: none !important; } div#dynamic_option_id_1004>label { display: none !important; }';
    (document.head || document.documentElement).appendChild(style);
  }

  function getNextOpenLabel() {
    var p = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', hour: '2-digit', hour12: false, weekday: 'short' })
      .formatToParts(new Date()).reduce(function (a, x) { a[x.type] = x.value; return a; }, {});
    var hour = parseInt(p.hour, 10);
    var dow  = p.weekday;
    var weekday = ['Mon','Tue','Wed','Thu','Fri'].indexOf(dow) > -1;
    var inHours = weekday && hour >= 9 && hour < 18;
    if (inHours) return null;
    if (dow === 'Sat' || dow === 'Sun' || (dow === 'Fri' && hour >= 18)) return 'by 10 AM EST Monday';
    if (weekday && hour < 9) return 'today by 10 AM EST';
    return 'tomorrow by 10 AM EST';
  }

  function updatePromiseText() {
    var label = getNextOpenLabel();
    if (!label) return;
    var fullEls = document.querySelectorAll('.mgs-fq-promise .mgs-fq-text-full');
    var shortEls = document.querySelectorAll('.mgs-fq-promise .mgs-fq-text-short');
    for (var i = 0; i < fullEls.length; i++) fullEls[i].textContent = "We'll email your exact shipping cost " + label + ".";
    for (var j = 0; j < shortEls.length; j++) shortEls[j].textContent = "Exact shipping cost " + label + ".";
  }

  function readField(name, root) {
    var els = $all('[data-mgs-fq-field="' + name + '"]', root);
    if (!els.length) return '';
    return (els[0].value || '').trim();
  }

  function readProductContext() {
    var variantInput =
      $('form[action*="/cart/add"] input[name="id"]') ||
      $('form[action*="cart/add"] input[name="id"]') ||
      $('product-form input[name="id"]') ||
      $('input[name="id"][type="hidden"]');

    var variantId = (variantInput && variantInput.value) ? variantInput.value : null;

    if (!variantId) {
      try {
        var params = new URLSearchParams(window.location.search);
        var v = params.get('variant');
        if (v) variantId = String(v);
      } catch (_) {}
    }

    var product = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) || {};
    var variants = product.variants || [];
    var matched = variants.filter(function (v) { return String(v.id) === String(variantId); })[0] || variants[0] || {};

    if (!variantId && matched.id) {
      variantId = String(matched.id);
    }

    return {
      variant_id: variantId,
      sku: matched.sku || null,
      title: product.title || document.title || '',
      vendor: product.vendor || null,
      price_cents: matched.price || null,
      page_url: window.location.href
    };
  }

  function readFreightInputs(root) {
    return {
      email:        readField('email', root),
      delivery_zip: readField('delivery_zip', root),
      phone:        readField('phone', root),
      notes:        readField('notes', root),
      quantity:     readField('quantity', root)
    };
  }

  function deriveName(email) {
    // Return the full email as the first_name and an empty string for last_name
    // This removes all the splitting and 'Lead' fallback logic
    return { 
      first_name: email.trim(), 
      last_name: '' 
    };
  }

function validate(freight) {
    var errors = [];
    if (!freight.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(freight.email)) errors.push('Enter a valid email address.');
    if (!/^\d{5}$/.test(freight.delivery_zip)) errors.push('Enter a 5-digit ZIP code.');
    if (!freight.phone || freight.phone.replace(/\D/g, '').length < 10) errors.push('Enter a valid phone number.');
    return errors;
  }

  function hasValidEmailDomain(email) {
    var domain = ((email || '').split('@')[1] || '').trim().toLowerCase();
    if (!domain || domain.indexOf('.') === -1) return Promise.resolve(true);

    var controller = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    var timeoutId = controller ? setTimeout(function () { try { controller.abort(); } catch (_) {} }, 1500) : null;
    var opts = { headers: { 'Accept': 'application/dns-json' } };
    if (controller) opts.signal = controller.signal;

    var mxUrl = 'https://dns.google/resolve?name=' + encodeURIComponent(domain) + '&type=MX';
    var aUrl  = 'https://dns.google/resolve?name=' + encodeURIComponent(domain) + '&type=A';

    return Promise.all([fetch(mxUrl, opts), fetch(aUrl, opts)])
      .then(function (responses) { return Promise.all([responses[0].json(), responses[1].json()]); })
      .then(function (results) {
        if (timeoutId) clearTimeout(timeoutId);
        var mxData = results[0] || {};
        var aData  = results[1] || {};

        var hasMx = mxData.Status === 0 && Array.isArray(mxData.Answer) && mxData.Answer.length > 0;
        var hasA  = aData.Status  === 0 && Array.isArray(aData.Answer)  && aData.Answer.length  > 0;
        if (hasMx || hasA) return true;

        var mxConclusive = (mxData.Status === 0 || mxData.Status === 3);
        var aConclusive  = (aData.Status  === 0 || aData.Status  === 3);
        if (!mxConclusive || !aConclusive) return true;

        return false;
      })
      .catch(function (err) {
        if (timeoutId) clearTimeout(timeoutId);
        return true; 
      });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return c === '&' ? '&amp;' : c === '<' ? '&lt;' : c === '>' ? '&gt;' : c === '"' ? '&quot;' : '&#39;';
    });
  }

  function showError(root, message) {
    if (!root) return;
    var box = $('[data-mgs-fq-error]', root);
    if (!box) return;
    box.innerHTML = '<strong>' + escapeHtml(message) + '</strong>';
    box.hidden = false;
  }
  
  function clearError(root) {
    if (!root) return;
    var box = $('[data-mgs-fq-error]', root);
    if (box) box.hidden = true;
  }

  function showConfirmation(root) {
    if (!root) return;
    var ctaRow = $('.mgs-fq-cta-row', root);
    var skip = $('[data-mgs-fq-skip]', root);
    var grid = $('.mgs-fq-grid', root);
    var promise = $('.mgs-fq-promise', root);
    var confirmEl = $('[data-mgs-fq-confirm]', root);
    if (ctaRow) ctaRow.style.display = 'none';
    if (skip) skip.style.display = 'none';
    if (grid) grid.style.display = 'none';
    if (promise) promise.style.display = 'none';
    if (confirmEl) confirmEl.hidden = false;
  }

  function buildPayload(root) {
    var product = readProductContext();
    var freight = readFreightInputs(root);
    var name = deriveName(freight.email);
    var quantity = Math.max(1, Math.min(99, parseInt(freight.quantity, 10) || 1));
    return {
      product: {
        title: product.title,
        sku: product.sku,
        variant_id: product.variant_id,
        vendor: product.vendor,
        price_cents: product.price_cents,
        quantity: quantity
      },
      customer: {
        first_name: name.first_name,
        last_name: name.last_name,
        email: freight.email,
        phone: freight.phone
      },
      freight: {
        delivery_zip: freight.delivery_zip,
        notes: freight.notes
      },
      submitted_at: new Date().toISOString(),
      page_url: product.page_url,
      _form_version: 'phase1'
    };
  }

  var WEBHOOK_URL = 'https://flow-webhooks.k8s.eu.codecreationlabs.cloud/webhook/r64jtzwg';
  var API_KEY = '0k705p531u5a200o42115l6a2j0u197a3h1d120u63016l56377j3v741v6p587k';

  function submit(root) {
    if (!root) return;

    var honeypotEl = document.querySelector('[data-mgs-fq-honeypot]');
    if (honeypotEl && honeypotEl.value) { showConfirmation(root); return; }

    clearError(root);
    var freight = readFreightInputs(root);
    var errors = validate(freight);
    if (errors.length) { showError(root, errors[0]); return; }

    var btn = $('[data-mgs-fq-submit]', root);
    var originalHtml = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Checking…'; }

    hasValidEmailDomain(freight.email).then(function (domainOk) {
      if (!domainOk) {
        if (btn) { btn.disabled = false; btn.innerHTML = originalHtml; }
        showError(root, "Invalid email domain.");
        return;
      }

      var payload = buildPayload(root);
      if (btn) { btn.textContent = 'Sending…'; }

      fetch(WEBHOOK_URL, { 
        method: 'POST', 
        headers: { 
          'Content-Type': 'application/json',
          'X-Api-Key': API_KEY 
        }, 
        body: JSON.stringify(payload), 
        keepalive: true 
      })
      .then(function (res) { 
        if (!res.ok) throw new Error('HTTP ' + res.status); 
        return res.json(); 
      })
      .then(function () { 
        showConfirmation(root); 
      })
      .catch(function (err) {
        showError(root, "Couldn't send request.");
        if (btn) { btn.disabled = false; btn.innerHTML = originalHtml; }
      });
    });
  }

  // --- REPLACED ALL BLOAT WITH THIS SIMPLE FUNCTION ---
  function revealAndCheckAck() {
    // 1. Unhide any elements with the hidden class
    var hiddenElements = document.querySelectorAll('.mgs-fq-ack-hidden');
    for (var i = 0; i < hiddenElements.length; i++) {
      hiddenElements[i].classList.remove('mgs-fq-ack-hidden');
    }

    // 2. Find the checkbox (looks for inputs with "Shipping" in the name)
    var input = document.querySelector('input[type="checkbox"][name*="Shipping"]') || document.querySelector('input[type="checkbox"][name*="shipping"]');
    
    // 3. Check it and tell Shopify's cart it was checked
    if (input && !input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  function showSkipNote(root) {
    if (!root || root.querySelector('.mgs-fq-skip-note')) return;
    var note = document.createElement('div');
    note.className = 'mgs-fq-skip-note';
    note.textContent = "Got it — add this to your cart below and we'll email you about shipping costs after.";
    note.style.cssText = 'margin: 8px 0 12px; padding: 10px 12px; background: #ecfdf5; border-left: 3px solid #10b981; color: #065f46; font-size: 14px; line-height: 1.4; border-radius: 4px;';
    root.appendChild(note);
  }

  function handleSkip(root) {
    if (!root) return;
    skipUsed = true;
    
    // Call our new simple function
    revealAndCheckAck();

    var grid = $('.mgs-fq-grid', root);
    var ctaRow = $('.mgs-fq-cta-row', root);
    var promise = $('.mgs-fq-promise', root);
    var skipLink = $('[data-mgs-fq-skip]', root);
    var errorBox = $('[data-mgs-fq-error]', root);
    if (grid) grid.style.display = 'none';
    if (ctaRow) ctaRow.style.display = 'none';
    if (promise) promise.style.display = 'none';
    if (skipLink) skipLink.style.display = 'none';
    if (errorBox) errorBox.hidden = true;

    showSkipNote(root);

    var addToCartBtn = $('form[action*="/cart/add"] [type="submit"]');
    if (addToCartBtn && addToCartBtn.scrollIntoView) {
      try { addToCartBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (_) {}
    }
  }

function restoreForm(root) {
  if (!root) return;
  skipUsed = false;

  // 1. Remove the skip note
  var note = root.querySelector('.mgs-fq-skip-note');
  if (note) note.remove();

  // 2. Unhide original elements
  var grid = $('.mgs-fq-grid', root);
  var ctaRow = $('.mgs-fq-cta-row', root);
  var promise = $('.mgs-fq-promise', root);
  var skipLink = $('[data-mgs-fq-skip]', root);

  if (grid) grid.style.display = '';
  if (ctaRow) ctaRow.style.display = '';
  if (promise) promise.style.display = '';
  if (skipLink) skipLink.style.display = '';

  // 3. Target the container and handle both the class and the input state
  var container = document.querySelector('.mgs-ack-container');
  if (container) {
    // Re-apply the hidden class
    var ackWrapper = container.querySelector('.field.choice');
    if (ackWrapper) {
      ackWrapper.classList.add('mgs-fq-ack-hidden');
    }

    // Find and uncheck the input
    var input = container.querySelector('input[type="checkbox"]');
    if (input && input.checked) {
      input.checked = false;
      // Dispatch events to notify Shopify/Theme scripts of the change
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
}

  document.addEventListener('click', function (e) {
 var t = e.target;
  if (!t || !t.closest) return;

  var root = t.closest('[data-mgs-fq-root]');

  // Check if the click is inside the stable container (the <li>)
  var isAckContainer = !!t.closest('.mgs-ack-container');

  // Logic: Restore only if click is OUTSIDE the root form AND OUTSIDE the ack container
  if (skipUsed && !root && !isAckContainer) {
      var activeRoot = document.querySelector('[data-mgs-fq-root]');
      restoreForm(activeRoot);
      return;
  }
    var qtyBtn = t.closest('[data-mgs-fq-qty-action]');
    if (qtyBtn) {
      e.preventDefault();
      var root = qtyBtn.closest('[data-mgs-fq-root]');
      var input = root && root.querySelector('input[data-mgs-fq-field="quantity"]');
      if (input) {
        var current = parseInt(input.value, 10) || 1;
        var min = parseInt(input.min, 10) || 1;
        var max = parseInt(input.max, 10) || 99;
        var action = qtyBtn.getAttribute('data-mgs-fq-qty-action');
        var next = current;
        if (action === 'increment') next = Math.min(max, current + 1);
        else if (action === 'decrement') next = Math.max(min, current - 1);
        input.value = String(next);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    var s = t.closest('[data-mgs-fq-submit]');
    if (s) { e.preventDefault(); submit(s.closest('[data-mgs-fq-root]')); return; }
    var k = t.closest('[data-mgs-fq-skip]');
    if (k) { e.preventDefault(); handleSkip(k.closest('[data-mgs-fq-root]')); }
  });

  function startup() {
    injectStyle();
    updatePromiseText();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startup);
  } else {
    startup();
  }

  console.log('[mgs-fq] script loaded, delegation active (Simplified Version)');
})();